import { useEffect, useState } from 'react';
import { Button, Card, Form, Modal, Row, Space, Typography } from 'antd';
import { useDispatch } from 'react-redux';
import classNames from "classnames";

import { PageWrapper } from '@/components';
import { useNotification } from '@/hooks';
import { appConfigKeys } from "@/constants";
import ConfigForm from "@/containers/setting/ConfigForm";
import { appConfigActions } from "@/redux/actions";

import { CheckCircleFilled, CloseCircleFilled, SaveOutlined } from '@ant-design/icons';

import styles from '@/components/PageContainer/Save/index.module.scss';

const ConfigSavePage = () => {
    const objectName = "SMSConfig";

    const {showErrorMessage} = useNotification();
    const dispatch = useDispatch();
    const formId = `form-${objectName}`;

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [detailData, setDetailData] = useState({});
    const [errorData, setErrorData] = useState({});
    const [modalProps, setModalProps] = useState({isOpen: false, isSuccess: true});
    const [form] = Form.useForm();

    const breadcrumbs = [
        {breadcrumbName: 'Setting', paths: 'avoidDuplicate'},
        {breadcrumbName: "SMS Configuration", paths: 'avoidDuplicate1'},
    ];

    const onCancel = () => {
        setModalProps({isOpen: false, isSuccess: false});
    }

    const onUpdate = (values) => {
        setIsSubmitting(true);
        dispatch(appConfigActions.updateVietGuyConfig({
            params: {
                id: detailData.id,
                description: detailData.description,
                value: values,
            },
            onCompleted: response => {
                if (response?.result) {
                    onSaveSuccess(response.data);
                } else {
                    onSaveFail(response);
                }
            },
            onError: err => {
                onSaveFail(err);
            }
        }))
    }

    const onSaveFail = (err) => {
        setErrorData(err);
        setIsSubmitting(false);
        setModalProps({isOpen: true, isSuccess: false});
    }

    const onSaveSuccess = () => {
        setIsSubmitting(false);
        setModalProps({isOpen: true, isSuccess: true});
    }

    useEffect(() => {
        dispatch(appConfigActions.getVietGuyConfig({
            params: {key: appConfigKeys.SMS_VIETGUYS},
            onCompleted: response => {
                if (response?.result) {
                    setDetailData(response.data);
                } else {
                    showErrorMessage(`Get data failed. Please try again!`);
                }
            },
            onError: () => {
                showErrorMessage(`Get data failed. Please try again!`);
            }
        }))
    }, [])

    const onContinueEdit = () => {
        setModalProps({...modalProps, isOpen: false})
    }

    useEffect(() => {
        form.setFieldsValue(detailData.value);
    }, [form, detailData.value])

    return (
        <PageWrapper
            breadcrumbs={breadcrumbs}
        >
            <div className={styles.savePage}>
                <div className={classNames(styles.savePageForm)}>
                    <Card style={{borderRadius: 0, minHeight: '100%'}}>
                        <ConfigForm
                            form={form}
                            formId={formId}
                            detailData={detailData}
                            onSubmit={onUpdate}
                        />
                    </Card>
                </div>
                <div className={styles.actionBar}>
                    <Button form={formId} type="primary" htmlType="submit" loading={isSubmitting}
                            icon={<SaveOutlined/>}>
                        Save & Update
                    </Button>
                </div>
            </div>
            <Modal open={modalProps.isOpen}
                   onCancel={onCancel}
                   centered={true}
                   footer={[]}
            >
                <Row justify="center">
                    <Space direction="vertical" align="center" size="large">
                        {
                            modalProps.isSuccess ?
                                <>
                                    <CheckCircleFilled style={{fontSize: 70, color: '#52C41A'}}/>
                                    <Typography.Title level={3} style={{textTransform: "capitalize"}}>
                                        {`${objectName} updated successfully!`}
                                    </Typography.Title>
                                    <Space>
                                        <Button onClick={onContinueEdit}>
                                            Continue edit {objectName}
                                        </Button>
                                    </Space>
                                </>
                                :
                                <>
                                    <CloseCircleFilled style={{fontSize: 70, color: '#EB5757'}}/>
                                    <Typography.Title level={3} style={{textTransform: "capitalize"}}>
                                        {`Failed to updated ${objectName}.`}
                                    </Typography.Title>
                                    <Typography.Text style={{color: "#EB5757"}}>
                                        {errorData.message}
                                    </Typography.Text>
                                    <Space>
                                        <Button onClick={() => setModalProps({...modalProps, isOpen: false})}>
                                            Continue update
                                        </Button>
                                    </Space>
                                </>
                        }
                    </Space>
                </Row>
            </Modal>
        </PageWrapper>
    )
}

export default ConfigSavePage;